export const mixin = {
  data() {
    return {
      handle: 0,
      showModal: false,
      modalTitle: "",
      modalMessage: "",
      openedMenu: false,
    };
  },

  computed: {
    linguaPortuguesa() {
      return (
        navigator.language === "pt" ||
        navigator.language === "pt-BR" ||
        navigator.language === "pt-br" ||
        navigator.language === "pt-pt" ||
        navigator.language === "pt-PT"
      );
    },
  },

  methods: {
    notify(title, message) {
      this.$notification.show(
        title,
        {
          body: message,
        },
        {}
      );
    },
    notifyVue(verticalAlign, horizontalAlign, message, type) {
      this.$notifications.notify({
        message: message,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
    lotteryTimesUp() {
      const currentTime = Date.now();
      const nextLotteryTime = parseInt(localStorage.nextLotteryTime);
      const lotteryTime = parseInt(localStorage.lotteryTime);
      if (
        nextLotteryTime < currentTime &&
        currentTime < nextLotteryTime + lotteryTime * 3
      ) {
        this.newMemberLotteryDrawn();
      }
      return false;
    },
    enableLotteryCheck() {
      this.handle = setInterval(this.lotteryTimesUp, 1000);
    },
    disableLotteryCheck() {
      clearInterval(this.handle);
      this.handle = 0;
    },
    updateLotteryTime() {
      const now = Date.now();
      localStorage.lastLotteryTime = now;
      localStorage.nextLotteryTime = now + parseInt(localStorage.lotteryTime);
    },
    newMemberLotteryDrawn() {
      const key = Math.floor(Math.random() * 100) + 1;
      const members = JSON.parse(localStorage.members);
      const memberIndex = (members.length % key) - 1;
      const memberDrawn = members[memberIndex].text;
      this.notifyProperly(memberDrawn);
      this.updateLotteryTime();
    },
    notifyProperly(memberDrawn) {
      const title = this.$t("modal.title");
      const modalMessage = this.$t("modal.description", { drawn: memberDrawn });
      const notifyMessage = this.$t("modal.notify", { drawn: memberDrawn });

      // Defines notify method (Push Notification or Modal Notification)
      if (this.tabIsVisible) {
        this.openModal(title, modalMessage);
      } else {
        this.notify(title, notifyMessage);
        this.openModal(title, modalMessage);
      }
    },
    openModal(title, message) {
      window.scrollTo(0, 0);
      this.modalTitle = title;
      this.modalMessage = message;
      this.showModal = true;
    },
  },
};
